module.exports = __webpack_public_path__ + "static/media/intro-animation3.48316be6.png";